import React, { Component } from 'react';

import { 
  Navbar,
  NavbarBrand,
  Button
} from 'reactstrap';

import axios from 'axios';

import { FaHome, FaDownload } from "react-icons/fa";

import * as Constants from "./Constants.js";

class ViewNavigation extends Component {
  constructor(props) {
    super(props);
    this.downloadResultsButton = React.createRef();
  }
  
  handleAnchorClick = (o) => {
    window.location.href = o.href;
  }
  
  handleClick = (event) => {
    var self = this;
    document.activeElement.blur();
    event.preventDefault();
    event.stopPropagation();
    //var targetAttr = event.target.target;
    var name = event.target.name;
    if (name === 'downloadResults') {
      axios.get(this.props.archiveURL, { responseType: 'blob' })
        .then(function(response) {
          let id = self.props.uuid;
          let fn = "epilogos-meme." + id + ".tbz2";
          self.downloadBlobAsFile(new Blob([response.data], {type: "application/bzip2"}), fn);
        })
        .catch(function(error) {
          console.log(error);
        })
    }
  }
  
  downloadBlobAsFile = (blob, fileName) => {
    var a = document.createElement("a");
    var objectURL = URL.createObjectURL(blob);
    a.href = objectURL;
    a.style.display = "none";
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    setTimeout(function(){
        document.body.removeChild(a);
        window.URL.revokeObjectURL(objectURL);  
    }, 100);
  }
    
  render() {
    return (
      <div>
        <Navbar color="#000000" fixed="true" expand="md" style={{backgroundColor:"#000000", cursor:"default", position:"fixed", overflow:"hidden", width:"100%", top:"0px", zIndex:"100"}}>
          <NavbarBrand className="mr-auto brand-content-portal">
            <div className="brand-content-header-portal brand-content-text-portal" onClick={(e)=>{this.onClick(e)}} data-id={Constants.epilogosMemeURL} data-target="_self">{!this.props.description && "epilogos Search"}</div>
            <div className="brand-content-header-viewer brand-content-text-viewer">{this.props.description && <FaHome className="brand-content-text-viewer-home" onClick={(e)=>{window.location=Constants.epilogosMemeURL}} />}{this.props.description && this.props.description.replace(/_/g, ' ')}</div>
          </NavbarBrand>
          <div className={this.props.archiveURL === "" ? 'hidden' : ''}>
            <form className="navbar-form navbar-right" role="download">
              <Button 
                className="btn-download" 
                color="success" 
                name="downloadResults" 
                ref={(thisButton) => {this.downloadResultsButton = thisButton}} 
                onClick={this.handleClick} >
                <FaDownload /> Download
              </Button>
            </form>
          </div>
        </Navbar>
      </div>
    );
  }
}

export default ViewNavigation;